//  倒计时
export function countTime (endTime) {
  // 获取当前时间
  const now = new Date().getTime()
  // 设置截止时间
  const end = endTime
  // 时间差
  const leftTime = end - now
  // 定义变量 d,h,m,s保存倒计时的时间
  if (leftTime >= 0) {
    // 天
    const day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
    // 时
    const h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
    const hour = h < 10 ? '0' + h : h
    // 分
    const m = Math.floor(leftTime / 1000 / 60 % 60)
    const min = m < 10 ? '0' + m : m
    // 秒
    const s = Math.floor(leftTime / 1000 % 60)
    const second = s < 10 ? '0' + s : s
    return { day, hour, min, second }
  } else {
    const day = '0'
    const hour = '00'
    const min = '00'
    const second = '00'
    return { day, hour, min, second }
  }
}
